/** Session state for Porto → Benvenuto → Mappa di Terra funnel. */

export const PORTO_SESSION_KEY = "6amico_porto_journey";

/** URL slug (giulianova) → puntiMappa port id */
export const PORTO_SLUG_TO_ID = {
  giulianova: "porto-giulianova",
  pescara: "porto-pescara",
};

export const PORTO_ID_TO_SLUG = Object.fromEntries(
  Object.entries(PORTO_SLUG_TO_ID).map(([slug, id]) => [id, slug]),
);

export function clearPortoJourney() {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(PORTO_SESSION_KEY);
  } catch {
    /* noop */
  }
}

export function readPortoJourney() {
  if (typeof sessionStorage === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(PORTO_SESSION_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function writePortoJourney(patch) {
  if (typeof sessionStorage === "undefined") return;
  const next = { ...readPortoJourney(), ...patch, updatedAt: new Date().toISOString() };
  sessionStorage.setItem(PORTO_SESSION_KEY, JSON.stringify(next));
}

export function clearWelcomeDismissed() {
  const { welcomeDismissed: _d, ...rest } = readPortoJourney();
  writePortoJourney(rest);
}

export function markWelcomeDismissed(portoSlug) {
  writePortoJourney({ welcomeDismissed: true, portoSlug });
}

export function activateTerraFromPorto(portoSlug, extras = {}) {
  writePortoJourney({
    fromPorto: true,
    portoSlug: portoSlug || "giulianova",
    terraActivatedAt: new Date().toISOString(),
    mappaAttiva: "TERRA_BORGHI",
    ...extras,
  });
}

/** Persiste filtro / comune per deep link Inter-Mappa. */
export function syncPortoJourneyDashboard({ filtroAttivo, comuneSlug, mappaAttiva } = {}) {
  const patch = {};
  if (filtroAttivo) patch.filtroAttivo = filtroAttivo;
  if (comuneSlug) patch.comuneSlug = comuneSlug;
  if (mappaAttiva) patch.mappaAttiva = mappaAttiva;
  if (Object.keys(patch).length) writePortoJourney(patch);
}

export function readPortoJourneyFiltro() {
  const j = readPortoJourney();
  return j.filtroAttivo || null;
}

export function parsePortoFromSearchParams(searchParams) {
  const porto = (searchParams.get("porto") || "").trim().toLowerCase();
  const fromPorto =
    searchParams.get("fromPorto") === "1" || searchParams.get("fromPorto") === "true";
  const mode = (searchParams.get("mode") || "").toLowerCase();
  const focus = (searchParams.get("focus") || "").toLowerCase();
  const welcome =
    searchParams.get("welcome") === "1" || searchParams.get("welcome") === "true";
  return { porto, fromPorto, mode, focus, welcome };
}

export function terraMapPath({ portoSlug = "giulianova", focus, comuneSlug } = {}) {
  const portoId = PORTO_SLUG_TO_ID[portoSlug] || `porto-${portoSlug}`;
  const params = new URLSearchParams({
    mode: "terra",
    fromPorto: portoId,
    porto: portoSlug,
  });
  if (focus) params.set("focus", focus);
  if (comuneSlug) params.set("comune", comuneSlug.replace(/^comune-/, ""));
  return `/mappa-globale?${params.toString()}`;
}

export function mareMapPath() {
  return "/mappa-globale?mode=mare";
}
